import { Box, Container, Divider, Text, Flex } from "@chakra-ui/react";
import React from "react";
import versionData from "../version/version.json";
import { colors } from "../theme/tokens";

const Footer: React.FC = () => {
  return (
    <Box
      as="footer"
      bg={colors.footerBackground}
      borderTop="1px solid"
      borderColor={colors.footerBorder}
      py={4}
    >
      <Container maxW="6xl">
        {/* Enhanced disclaimer on top */}
        <Text fontSize="sm" textAlign="center" color={colors.disclaimerText} mb={3}>
          <strong>IMPORTANT DISCLAIMER:</strong> The information provided on
          this website is for general informational purposes only. We are NOT
          immigration lawyers, government officials, or authorized visa
          representatives. Always verify visa requirements directly with
          official embassy or consulate sources before travel. Visa requirements
          may change without notice and may vary based on individual
          circumstances. The user of this website alone is responsible for any
          visa decisions.
        </Text>

        <Divider my={3} borderColor={colors.footerDivider} />

        {/* Version and copyright on bottom */}
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          fontSize="sm"
        >
          <Text color={colors.bodyText}>
            © {new Date().getFullYear()} Visa Cheatsheet. All rights reserved.
            Unauthorized reproduction or distribution of this content is
            prohibited.
          </Text>

          <Text color={colors.versionText}>
            Version {versionData.version} • Built {versionData.buildDate}
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
